// @flow

// TODO: must be used by the selector, and all the callers to that function must use the selector
export const getGeoOsmString = (geoOsm: Array<GeoOsm>, numVisibleItems: number): string => {
  let geoOsmItems = geoOsm.filter(osmItem => osmItem.visible).reverse();

  if (numVisibleItems !== -1) {
    geoOsmItems = geoOsmItems.slice(0, numVisibleItems);
  }

  return geoOsmItems.map(osmItem => (osmItem ? osmItem.name : '')).join(', ');
};



// WEBPACK FOOTER //
// ./app/utils/geoOsm/utils.js